/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.2 2.6h13.6c.66 0 1.2.54 1.2 1.2a8 8 0 0 1-16 0c0-.66.54-1.2 1.2-1.2",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.6 11.8H7.4v2.94A2.4 2.4 0 0 0 5.8 17h6.4a2.4 2.4 0 0 0-1.6-2.26z",
                fill: "#fff"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M7.4 11.8v-1a1 1 0 0 0-1 1zm3.2 0h1a1 1 0 0 0-1-1zm-3.2 2.94.33.94a1 1 0 0 0 .67-.94zM5.8 17h-1a1 1 0 0 0 1 1zm6.4 0v1a1 1 0 0 0 1-1zm-1.6-2.26h-1c0 .42.27.8.67.94zM7.4 12.8h3.2v-2H7.4zm1 1.94V11.8h-2v2.94zM6.8 17c0-.6.39-1.13.93-1.32l-.66-1.89A3.4 3.4 0 0 0 4.8 17zm5.4-1H5.8v2h6.4zm-1.93-.32c.54.2.93.71.93 1.32h2a3.4 3.4 0 0 0-2.27-3.2zM9.6 11.8v2.94h2V11.8z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.2 3.4A2.4 2.4 0 0 1 6.6 1h4.8a2.4 2.4 0 0 1 2.4 2.4v4.8a4.8 4.8 0 1 1-9.6 0z",
                fill: "#fff",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m9 7.96-1.17.59c-.26.13-.43 0-.38-.27l.22-1.25-.95-.89c-.2-.2-.14-.39.15-.43l1.3-.18.6-1.14c.12-.25.34-.25.47 0l.58 1.14 1.31.18c.3.04.36.24.15.43l-.95.89.22 1.25c.05.28-.12.4-.38.27z",
                fill: "currentColor"
            })
        ]
    }));
};
export default SvgComponent;
